<microsec-form-builder
  #fb
  [isPage]="true"
  [fields]="fields"
  [shouldShowActionButtons]="!!permissions[USER_ROLE.TECHNICIAN]"
  submitButtonLabel=""
  cancelButtonLabel=""
  (submitEvent)="onSubmit()"
  [additionalConditions]="!!form && !!form.getControlValue(FORM_PARAMS.COMMENT) && !!isValidLicense()"
  [leftActionArea]="leftTemplate" />

<ng-template #leftTemplate>
  <div [pTooltip]="!isValidLicense() ? INACTIVE_LICENSE : ''" tooltipPosition="bottom" appendTo="body">
    <p-button [label]="SAVE_CHANGES_LABEL" severity="success" [disabled]="!isValidLicense()" (onClick)="onSubmit()" />
  </div>
</ng-template>
